import React from 'react';
import {
	Card, Row, Col, Input, Button, Table, Modal, Form, DatePicker,
	message, Tag, Tooltip, Typography, Pagination, Divider,
} from 'antd';
import {
	SearchOutlined, RedoOutlined, CloseCircleOutlined,
	FileOutlined, HistoryOutlined, FileSearchOutlined,
	CalendarOutlined, BankOutlined,
} from '@ant-design/icons';
import {
	AiOutlineCloudUpload,
	AiOutlineEye,
	AiOutlineFilePdf,
} from 'react-icons/ai';
import moment from 'moment';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig, ajaxDownloadHandler,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { RangePicker } = DatePicker;

const configClass = {
	title: 'Data SMDD',
	apiUrl: {
		data: 'transaksi/api/smdd/',
		genPDF: 'laporan/api/genpdf/',
	},
};

const config = new Config();

class DataSmdd extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg:       '',
			errTitle:     '',
			loadingData:  false,
			pagination:   { current: 1, pageSize: 25, total: 0 },
			dataSource:   [],
			searchText:   '',
			filterTanggal: null,
			isMobile:     window.innerWidth <= 768,
			visibleModal: false,
			dataModal:    null,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	_buildParams(page = 1) {
		const { pagination, searchText, filterTanggal } = this.state;
		const limit = pagination.pageSize;
		const offset = (page - 1) * limit;
		let q = `?limit=${limit}&offset=${offset}`;
		if (searchText) q += `&search=${encodeURIComponent(searchText)}`;
		if (filterTanggal && filterTanggal[0]) q += `&tanggal_mulai=${filterTanggal[0].format('DD-MM-YYYY')}`;
		if (filterTanggal && filterTanggal[1]) q += `&tanggal_akhir=${filterTanggal[1].format('DD-MM-YYYY')}`;
		return q;
	}

	async getData(page = 1) {
		this.setState({ loadingData: true, errTitle: '', errMsg: '' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + this._buildParams(page))
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({
						dataSource: data.results || [],
						pagination: { ...prev.pagination, current: page, total: data.count || 0 },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	async doRequest(id, code) {
		message.loading({ content: `Memproses ${code}...`, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/' + code)
			.then(() => {
				if (this.props.isSuccess) {
					this.getData(this.state.pagination.current);
					if (code === 'monitor_smdd') {
						message.success({ content: 'Lihat status file berhasil', duration: 2, key: 'toast' });
						this.showDetail('STATUS FILE', this.props.responseMsg, true);
					} else if (code === 'upload_smdd') {
						message.success({ content: 'Upload file berhasil', duration: 2, key: 'toast' });
						this.showDetail('STATUS UPLOAD', this.props.responseMsg, false);
					} else {
						message.success({ content: `${code} berhasil`, duration: 2, key: 'toast' });
					}
				} else {
					message.error({ content: `Gagal ${code}`, duration: 2, key: 'toast' });
					this.setState({ errTitle: `Gagal ${code}`, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: `${code} gagal, coba lagi`, duration: 2, key: 'toast' }));
	}

	async doGenPDF(id, code) {
		message.loading({ content: 'Membuat PDF...', key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.genPDF + id + '/' + code)
			.then(() => {
				if (this.props.isSuccess) {
					this.getData(this.state.pagination.current);
					const labels = {
						lap_kasir: 'PDF Laporan Kasir berhasil dibuat',
						slip_setor: 'PDF Slip Setor Bank berhasil dibuat',
						lap_sum32: 'PDF SUM 32 berhasil dibuat',
					};
					message.success({ content: labels[code] || `${code} berhasil`, duration: 2, key: 'toast' });
				} else {
					message.error({ content: `Gagal membuat PDF ${code}`, duration: 2, key: 'toast' });
					this.setState({ errTitle: `Gagal PDF ${code}`, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Gagal membuat PDF, coba lagi', duration: 2, key: 'toast' }));
	}

	showDetail = (judul, dataModal, is_flat = false) => {
		if (!is_flat) {
			this.setState({ visibleModal: true, dataModal: { is_flat, judul, konten: dataModal } });
		} else {
			this.setState({ visibleModal: true, dataModal: { is_flat, judul, konten: { kolom: judul, value: JSON.stringify(dataModal, null, 2) } } });
		}
	};

	handleFilter = () => this.getData(1);

	handleReset = () => {
		this.setState({ searchText: '', filterTanggal: null }, () => this.getData(1));
		if (this.formRef.current) this.formRef.current.resetFields();
	};

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => this.getData(1), 400);
	};

	_renderDokumenCell(row, dokumenPrefix, label, pdfCode, canUpload = true) {
		const data = row?.data || {};
		const dokumenKey = Object.keys(data).find(k => k === dokumenPrefix || k.startsWith(dokumenPrefix));
		const dokumenList = data[dokumenKey] || data.dokumen_ || [];
		const dokumen = dokumenList?.[0] || null;

		const idDoc = dokumen?.id_dokumen || dokumenPrefix.split('_')[1];
		const refKey = `${row.id}to${idDoc}`;
		const status = Number(dokumen?.status_dokumen ?? -1);

		const BtnPDF = (
			<Tooltip key="pdf" title="Generate PDF">
				<Button size="small" className="btn-data" shape="circle" onClick={() => this.doGenPDF(refKey, pdfCode)}>
					<AiOutlineFilePdf />
				</Button>
			</Tooltip>
		);
		const BtnStatus = (
			<Tooltip key="status" title="Lihat Status">
				<Button size="small" className="btn-data" shape="circle" onClick={() => this.doRequest(refKey, 'monitor_smdd')}>
					<AiOutlineEye />
				</Button>
			</Tooltip>
		);
		const BtnUpload = (
			<Tooltip key="upload" title="Upload File">
				<Button size="small" className="btn-resend" shape="circle" onClick={() => this.doRequest(refKey, 'upload_smdd')}>
					<AiOutlineCloudUpload />
				</Button>
			</Tooltip>
		);

		if (!dokumen) {
			return (
				<div style={{ textAlign: 'center' }}>
					<Tag color="error">Tidak Ada Dokumen</Tag>
					<div style={{ marginTop: 6 }}>{BtnPDF}</div>
				</div>
			);
		}

		const statusMap = {
			0: { color: 'error',      text: 'Tidak Ditemukan File', actions: [BtnPDF] },
			1: { color: 'warning',    text: 'Pending',              actions: [BtnPDF, BtnStatus, BtnUpload] },
			2: { color: 'processing', text: 'Terkirim',             actions: [BtnPDF, BtnStatus, BtnUpload] },
			3: { color: 'success',    text: 'Verifikasi',           actions: [BtnStatus] },
		};
		const current = statusMap[status] || { color: 'default', text: 'Tidak Diketahui', actions: [BtnPDF] };

		return (
			<div style={{ textAlign: 'center' }}>
				<Tag color={current.color}>{current.text}</Tag>
				<div style={{ marginTop: 6, display: 'flex', gap: 4, justifyContent: 'center' }}>{current.actions}</div>
			</div>
		);
	}

	_buildColumns() {
		return [
			{
				title: 'Tanggal', dataIndex: 'tgl_transaksi', key: 'tgl_transaksi', width: 110,
				render: (v) => <Text style={{ fontSize: 12, color: '#555' }}>{v || '—'}</Text>,
			},
			{
				title: 'Kode Berkas', dataIndex: 'kode_berkas', key: 'kode_berkas', width: 130,
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: '#0f2847' }}>{v || '—'}</Text>,
			},
			{
				title: 'Lap. Kasir', dataIndex: 'lap_120', width: 160,
				render: (_, row) => this._renderDokumenCell(row, 'dokumen_120', 'Laporan Kasir', 'lap_kasir'),
			},
			{
				title: 'Lap. Harian / SUM32 / SUM33', dataIndex: 'lap_127', width: 195,
				render: (_, row) => this._renderDokumenCell(row, 'dokumen_127', 'Laporan SUM32', 'lap_sum32'),
			},
			{
				title: 'Lap. Rekap Setor Uang', dataIndex: 'lap_149', width: 185,
				render: (_, row) => this._renderDokumenCell(row, 'dokumen_149', 'Rekap Setor', 'slip_setor'),
			},
			{
				title: 'Dibuat', dataIndex: 'created', key: 'created', width: 155,
				render: (v) => <Text style={{ fontSize: 12, color: '#666' }}>{v ? moment(v).format('DD-MM-YYYY HH:mm:ss') : '—'}</Text>,
			},
		];
	}

	renderDetailModal() {
		const { visibleModal, dataModal, isMobile } = this.state;
		if (!dataModal) return null;

		const isData  = !dataModal.is_flat;
		const isLog   = dataModal.is_flat;
		const icon    = isData ? <FileSearchOutlined /> : <HistoryOutlined />;
		const titleLabel  = isData ? 'Detail Data' : 'Log / Status';
		const accentBg    = isData
			? 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)'
			: 'linear-gradient(135deg, #7c3d00 0%, #d46b08 60%, #a05000 100%)';
		const accentColor = isData ? '#1e4d8a' : '#d46b08';

		const entries = isData
			? Object.entries(dataModal.konten).filter(([, v]) => typeof v !== 'object' || v === null)
			: null;

		const header = (
			<div style={{ background: accentBg, borderRadius: isMobile ? 0 : '10px 10px 0 0', padding: isMobile ? '16px 18px' : '22px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14 }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{ width: isMobile ? 38 : 48, height: isMobile ? 38 : 48, flexShrink: 0, borderRadius: 12, background: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						{React.cloneElement(icon, { style: { color: '#fff', fontSize: isMobile ? 18 : 22 } })}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>{titleLabel}</div>
						{!isMobile && <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>{dataModal.judul}</div>}
					</div>
				</div>
				<Button type="text" icon={<CloseCircleOutlined style={{ fontSize: 18 }} />}
					onClick={() => this.setState({ visibleModal: false })}
					style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }} />
			</div>
		);

		const content = (
			<div style={{ maxHeight: isMobile ? '55vh' : '60vh', overflowY: 'auto', padding: isMobile ? '14px 16px' : '20px 28px' }}>
				{isData && entries && (
					<div>
						{entries.map(([key, value], i) => (
							<div key={key} style={{ display: 'flex', gap: 12, padding: '9px 12px', background: i % 2 === 0 ? '#f9fbff' : '#fff', borderRadius: 8, marginBottom: 4, border: '1px solid #edf2f9', flexDirection: isMobile ? 'column' : 'row' }}>
								<div style={{ flexShrink: 0, width: isMobile ? '100%' : 200, fontSize: 12, fontWeight: 600, color: accentColor, paddingRight: 8, borderRight: isMobile ? 'none' : '2px solid #d0dff5', marginRight: isMobile ? 0 : 4, paddingBottom: isMobile ? 2 : 0, borderBottom: isMobile ? '1px dashed #e0e8f5' : 'none', fontFamily: 'monospace', letterSpacing: 0.3 }}>
									{key}
								</div>
								<div style={{ flex: 1, fontSize: 13, color: '#222', fontWeight: 500, wordBreak: 'break-all' }}>
									{value !== null && value !== undefined ? String(value) : <Text type="secondary">—</Text>}
								</div>
							</div>
						))}
						{entries.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: '#aaa', fontSize: 13 }}>Tidak ada data</div>}
					</div>
				)}
				{isLog && (
					<div style={{ background: '#0f2847', color: '#7dd3fc', padding: isMobile ? 14 : 20, borderRadius: 10, fontFamily: 'monospace', fontSize: isMobile ? 11 : 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all', lineHeight: 1.7, border: '1px solid #1e4d8a', boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.3)' }}>
						{dataModal.konten.value || '—'}
					</div>
				)}
			</div>
		);

		const footer = (
			<div>
				<Divider style={{ margin: 0 }} />
				<div style={{ padding: isMobile ? '12px 16px' : '14px 28px', display: 'flex', justifyContent: 'flex-end', background: '#fafafa', borderRadius: isMobile ? 0 : '0 0 10px 10px' }}>
					<Button icon={<CloseCircleOutlined />} onClick={() => this.setState({ visibleModal: false })} style={{ borderRadius: 8, height: 38, minWidth: 100 }}>
						Tutup
					</Button>
				</div>
			</div>
		);

		return (
			<Modal
				visible={visibleModal}
				onCancel={() => this.setState({ visibleModal: false })}
				footer={null} title={null} closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 680}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 40 }}
				bodyStyle={{ padding: 0 }}
				maskClosable destroyOnClose
			>
				{header}{content}{footer}
			</Modal>
		);
	}

	renderMobileCard(row) {
		return (
			<Card key={row.id || row.kode_berkas} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
					<div style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<BankOutlined style={{ color: '#fff', fontSize: 17 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', fontFamily: 'monospace' }}>{row.kode_berkas || '—'}</div>
						<div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
							<CalendarOutlined style={{ marginRight: 4, color: '#1e4d8a' }} />{row.tgl_transaksi || '—'}
						</div>
					</div>
				</div>

				<div style={{ padding: '10px 14px' }}>
					{[
						{ label: 'Lap. Kasir', prefix: 'dokumen_120', pdfCode: 'lap_kasir' },
						{ label: 'Lap. Harian / SUM32 / SUM33', prefix: 'dokumen_127', pdfCode: 'lap_sum32' },
						{ label: 'Lap. Rekap Setor Uang', prefix: 'dokumen_149', pdfCode: 'slip_setor' },
					].map(({ label, prefix, pdfCode }) => (
						<div key={prefix} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: '1px dashed #eee' }}>
							<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>{label}</div>
							{this._renderDokumenCell(row, prefix, label, pdfCode)}
						</div>
					))}
				</div>

				{row.created && (
					<div style={{ padding: '8px 14px', background: '#f9fbff', borderTop: '1px solid #edf2f9' }}>
						<Text style={{ fontSize: 11, color: '#888' }}>
							<CalendarOutlined style={{ marginRight: 4 }} />
							{moment(row.created).format('DD-MM-YYYY HH:mm:ss')}
						</Text>
					</div>
				)}
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText, filterTanggal } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.smdd-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 12px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.smdd-wrap .ant-table-tbody > tr > td { padding: 10px 14px; vertical-align: middle; }
						.smdd-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.smdd-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.smdd-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.smdd-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 12px; }
						.smdd-wrap .ant-picker, .smdd-wrap .ant-input { border-radius: 8px !important; }
					`}</style>
				</Helmet>

				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />
				{this.renderDetailModal()}

				<Card className="smdd-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>

					{/* Header */}
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<BankOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} record{loadingData && ' · Memuat...'}
							</div>
						</div>
						<Tooltip title="Refresh">
							<Button icon={<RedoOutlined />} onClick={() => this.getData(pagination.current)} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>

					{/* Filter */}
					<div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Form ref={this.formRef} layout="vertical" onFinish={this.handleFilter}>
							<Row gutter={[12, 0]} align="bottom">
								<Col xs={24} sm={12} md={8} lg={7}>
									<Form.Item label="Rentang Tanggal" style={{ marginBottom: 0 }}>
										<RangePicker
											style={{ width: '100%', borderRadius: 8 }}
											format="DD-MM-YYYY"
											value={filterTanggal}
											onChange={(v) => this.setState({ filterTanggal: v })}
											placeholder={['Dari tanggal', 'Sampai tanggal']}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={8} lg={9}>
									<Form.Item label="Pencarian" style={{ marginBottom: 0 }}>
										<Input
											placeholder="Kode berkas, tanggal..."
											prefix={<SearchOutlined style={{ color: '#bbb' }} />}
											allowClear style={{ borderRadius: 8 }}
											value={searchText}
											onChange={this.handleSearchChange}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8} lg={8}>
									<Form.Item style={{ marginBottom: 0 }}>
										<div style={{ display: 'flex', gap: 8, justifyContent: isMobile ? 'stretch' : 'flex-end', marginTop: isMobile ? 8 : 0 }}>
											<Button onClick={this.handleReset} style={{ borderRadius: 8, flex: isMobile ? 1 : 'unset' }}>Reset</Button>
											<Button type="primary" icon={<SearchOutlined />} htmlType="submit" loading={loadingData}
												style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, flex: isMobile ? 1 : 'unset' }}>
												Filter
											</Button>
										</div>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>

					{/* Info bar */}
					<div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafcff' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData
									? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Memuat data...</div>
									: dataSource.length === 0
										? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Tidak ada data</div>
										: dataSource.map(row => this.renderMobileCard(row))
								}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
											onChange={(page) => this.getData(page)} showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey={(row) => row.id || row.kode_berkas}
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
									onChange: (page, pageSize) => {
										this.setState(prev => ({ pagination: { ...prev.pagination, pageSize } }), () => this.getData(page));
									},
								}}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler, ajaxDownloadHandler })(DataSmdd);
